const initialState = {
  payments: [],
  typeTotals: [],
  buyOffers: [],
  crossCheckPayments: null,
  missingCodes: null,
  page: 1,
  createModalActive: false,
  crossCheckModalActive: false,
  createFormState: {
    data: {
      payments: [
      ]
    },
  },
  crossCheckFormState: {
    data: {
    },
  },
  filtersFormState: {
    data: {
      sort: 'remainingValue',
    }
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_PAYMENTS': {
      const { payments, page, typeTotals } = payload;
      return {
        ...state,
        payments,
        typeTotals,
        page,
      };
    }
    case 'SET_CROSS_CHECK_PAYMENTS': {
      const { payments, missingCodes } = payload;
      return {
        ...state,
        crossCheckPayments: payments,
        missingCodes,
      };
    }
    case 'TOGGLE_MODAL': {
      const { active } = payload;
      return {
        ...state,
        createModalActive: active,
        createFormState: initialState.createFormState,
      };
    }
    case 'TOGGLE_CROSS_CHECK_MODAL': {
      const { active } = payload;
      return {
        ...state,
        crossCheckModalActive: active,
        crossCheckFormState: initialState.crossCheckFormState,
        crossCheckPayments: initialState.crossCheckPayments,
        missingCodes: initialState.missingCodes,
      };
    }
    case 'FETCH_CROSS_CHECK_PAYMENTS': {
      return {
        ...state,
        crossCheckPayments: initialState.crossCheckPayments,
        missingCodes: initialState.missingCodes,
      };
    }
    case 'SET_OFFERS_FOR_PAYMENTS': {
      const { offers } = payload;
      return {
        ...state,
        buyOffers: offers.filter(offer => offer.offer_type === 'buy'),
      };
    }
    case 'ON_PAYMENT_CREATE_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        createFormState: formState,
      };
    }
    case 'ON_CROSS_CHECK_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        crossCheckFormState: formState,
      };
    }
    case 'CREATE_FORM_ADD_PAYMENT': {
      return {
        ...state,
        createFormState: {
          ...state.createFormState,
          data: {
            ...state.createFormState.data,
            payments: state.createFormState.data.payments.concat({})
          }
        },
      };
    }
    case 'CREATE_FORM_REMOVE_PAYMENT': {
      const { index } = payload;
      let payments = state.createFormState.data.payments;
      payments = [
        ...payments.slice(0, index),
        ...payments.slice(index + 1),
      ];
      return {
        ...state,createFormState: {
          ...state.createFormState,
          data: {
            ...state.createFormState.data,
            payments,
          }
        },
      };
    }
    case 'PAYMENT_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'PAYMENTS_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'PAYMENTS_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/Payments.reducer.js